import React, { useEffect, useMemo, useState } from 'react';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import CheckboxDropdown from '../../Form/Inputs/CheckboxDropdown';
import { ChartStudyType } from './StudiesDefinitions';
import styles from './StudiesDropdown.module.scss';

export interface IStudiesDropdownProps {
    studies: ChartStudyType[];
    disabled?: boolean;
    includeErrorRange?: boolean;
    handleStudiesSelected: (studies: ChartStudyType[]) => void;
    track: TrackingEvent;
}

const maximumStudies = 5;
const availableStudies = Object.keys(ChartStudyType).filter((item) => Number.isNaN(Number(item))) as ChartStudyType[];

const StudiesDropdown: React.FC<IStudiesDropdownProps> = (props: IStudiesDropdownProps) => {
    const [translations] = useLanguage();
    const [studies, setStudies] = useState<ChartStudyType[]>(props.studies ?? []);

    const studiesOptions = useMemo(() => {
        let currentStudies = [...availableStudies];
        if (!props.includeErrorRange) {
            currentStudies = availableStudies.filter((item) => item !== ChartStudyType.ForecastErrorRange);
        }

        return currentStudies.map((study) => ({
            label: translations.chartStudy[study],
            value: study,
        }));
    }, [props.includeErrorRange]);

    useEffect(() => {
        setStudies(props.studies);
    }, [props.studies]);

    const handleClick = (selectedStudies: ChartStudyType[]) => {
        setStudies(selectedStudies);
        props.handleStudiesSelected(selectedStudies);
    };

    return (
        <div className={styles.studies_dropdown_container}>
            <CheckboxDropdown
                placeholder={translations.dropdown.studies}
                options={studiesOptions}
                values={studies}
                handleOptionSelect={handleClick}
                maximumSelectionLimit={maximumStudies}
                limitMessage={translations.dropdown.studiesLimitMessage}
                disabled={props.disabled}
                track={props.track}
            />
        </div>
    );
};

export default StudiesDropdown;
